module.exports = __webpack_public_path__ + "static/media/kebab.1a188a94.svg";